import { render, staticRenderFns } from "./DeliveryResult.vue?vue&type=template&id=25a40f92&"
import script from "./DeliveryResult.vue?vue&type=script&lang=js&"
export * from "./DeliveryResult.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports